module.exports = __webpack_public_path__ + "static/img/mask-group-1863.a28c22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/mask-group-1863.png
// module id = tucf
// module chunks = 0